export const offerListNumlabsCacheDayTime = 7;
export const offerListNumlabsCacheDayTime = 7;
